
export const hasPermission = (projectId, membership, type) => {
     return membership.find(membershipItem => membershipItem.projectId === projectId && membershipItem.memberType === type);
}

export const isDisabled = (user) => {
    return user.companyPlan.companySubscriptionState !== "OK"
}